import {Button, Container, Typography} from '@mui/material';
import {Link} from 'react-router-dom';

export default function ForbiddenPage() {
    return <Container sx={{py: 8, textAlign: 'center'}}>
        <Typography variant="h4" gutterBottom>Доступ заборонено</Typography>
        <Typography sx={{mb: 3}}>У вас немає прав для перегляду цієї сторінки.</Typography>
        <Button component={Link} to="/" variant="contained">До модуля бронювання</Button>
    </Container>;
}